import React, { useRef, useState, useCallback } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, A11y, Keyboard } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { Swiper as SwiperCore } from 'swiper/types'
import {
  PrevChevron,
  NextChevron
} from '@toasttab/shared/src/components/molecules/SliderNavigation/NavigationIcons'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import VideoCard from '@toasttab/main/src/components/Homepage/Cards/VideoCard'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { VideoCardProps } from '@toasttab/main/src/components/Homepage/Cards/VideoCard.d'

const Customers = ({ header, body }: { header: any; body: any }) => {
  const [prevActive, setPreviousActive] = useState(false)
  const [nextActive, setNextActive] = useState(true)

  const swiperRef = useRef<SwiperCore>(null)

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (!swiperRef.current) return

      if (e.key === 'ArrowLeft') {
        swiperRef.current.slidePrev()
      } else if (e.key === 'ArrowRight') {
        swiperRef.current.slideNext()
      }
    },
    []
  )

  return (
    <section className='mb-10 lg:mb-16 overflow-hidden'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12'>
            <div className='flex flex-col items-center max-w-[46.5rem] mb-10 mx-auto text-center'>
              <img
                alt='Locations'
                className='mb-4 mx-auto w-16 h-16'
                src={resolvePrefix(header.icon)}
              />
              <Typography
                as='h2'
                classes='font-effra font-base !leading-[2.5rem] !leading-[3rem] mb-4 !text-[1.938rem] lg:!text-[45px] text-gray-125'
                variation='h2'
              >
                {header.heading}
              </Typography>
            </div>
            <div
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyDown(e)
              }
            >
              <Swiper
                className='[&>.swiper-wrapper]:lg:flex [&>.swiper-wrapper]:lg:flex-nowrap [&>.swiper-wrapper]:lg:justify-center [&>.swiper-wrapper]:lg:gap-6'
                enabled={body.stories.length > 1}
                grabCursor
                loop={false}
                modules={[Navigation, A11y, Keyboard]}
                slidesPerView='auto'
                spaceBetween={24}
                speed={300}
                threshold={30}
                a11y={{
                  enabled: true,
                  slideLabelMessage: 'Slide {{index}} of {{slidesLength}}'
                }}
                breakpoints={{
                  1024: {
                    enabled: false,
                    slidesPerView: 'auto',
                    spaceBetween: 0
                  }
                }}
                keyboard={{
                  enabled: true,
                  onlyInViewport: true
                }}
                navigation={{
                  nextEl: '.swiper-next',
                  prevEl: '.swiper-prev'
                }}
                onBeforeInit={(swiper) => {
                  swiperRef.current = swiper
                }}
                onSlideChange={(swiper) => {
                  if (swiper.isEnd) {
                    setNextActive(false)
                  } else {
                    setNextActive(true)
                  }

                  if (swiper.isBeginning) {
                    setPreviousActive(false)
                  } else {
                    setPreviousActive(true)
                  }
                }}
              >
                {body.stories.map((customer: VideoCardProps, i: number) => (
                  <SwiperSlide className='!w-[264px] !border-box' key={i}>
                    <VideoCard {...customer} />
                  </SwiperSlide>
                ))}
              </Swiper>
              {body.stories.length > 1 && (
                <div className='flex justify-center mx-auto mt-10 lg:hidden'>
                  <PrevChevron
                    active={prevActive}
                    classes='mr-4'
                    heapInteraction='hplogos_backarrow_click'
                    size='large'
                  />
                  <NextChevron
                    active={nextActive}
                    heapInteraction='hplogos_forwardarrow_click'
                    size='large'
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Customers
